import { useEffect } from 'react';

import { useAuth } from '../context/AuthContext';

/** What the tab says once an agent is signed in, after their PCC. */
const APP_NAME = 'Agency Workspace';

/**
 * Keeps the browser tab named after the work area an agent is signed in to —
 * `KV6L | Agency Workspace` — the way the host names a session.
 *
 * The PCC is the only thing distinguishing one open tab from another, which is
 * why it leads: an agent working two agencies at once reads the tab strip, not
 * the page.
 */
export function DocumentTitle() {
  const { status, pcc, user } = useAuth();

  useEffect(() => {
    document.title = titleFor(status, pcc || user?.pcc);
  }, [status, pcc, user?.pcc]);

  return null;
}

function titleFor(status: string, pcc: string | undefined): string {
  if (status === 'authenticated') {
    return pcc ? `${pcc} | ${APP_NAME}` : APP_NAME;
  }
  // Before sign-in there is no PCC to name the tab after.
  return status === 'loading' ? APP_NAME : `Sign in | ${APP_NAME}`;
}
